export default {
  fr: {
    Title: "Coûts par activités",
    KpiTitle : "KPI",
    Year : "Annéee",
    Period : "Périodes",
    SelectPeriod : "Veuillez sélectionner une période",
    Projects : "Locations",
    SelectProject : "Veuillez sélectionner une location",
    OPEX : {
      Title : "Coûts de production",
      BaseValue : "($)",
      OPEXPerOz : "($ / oz)",
      OPEXPerTonOre : "($ / t Ore)",
      OPEXPerMadv : "($ / madv)",
      OPEXPerMdrl : "($ / mdrl)",
      OPEXPerTDev : "($ / tDev)",
      OPMining : "Opération Mine Ciel Ouvert",
      UGMining : "Opération Mine Souterrain",
      HLProcessing : "Traitememt de lixiviation en tas",
      MillProcessing : "Traitement à l'usine"
    },
    CAPEX : {
      Title : "CAPEX"
    },
    GoldProduction : {
      Title : "Production Au"
    },
    OreTons : {
      Title : "Tonnes de minerai"
    },
    Development : {
      Title : "Développement latéral",
      ShortTitle : "Développement",
      Drilling : "Forage de développement"
    },
    Production : "Production",
    Services : "Services",
    Maintenance : "Maintenance",
    Drilling : "Forage",
    Blasting : "Dynamitage",
    Mucking : "Havage",
    Hauling : "Manutention",
    MeterOfAdvance : "Metres d'avancement",
    MeterDrilled : "Metres de forage",
    UGDevelopmentOre : "Tonnes de minerai de dévelopment souterrain",
    DirectProductionExpensePerAccount : "Coûts de production par compte",
    PerformanceFactor1 : "Facteur de performance 1",
    PerformanceFactor2 : "Facteur de performance 2",
    PerformanceFactor3 : "Facteur de performance 3",
    PerformanceFactor4 : "Facteur de performance 4",
    Workforce : "Main d'oeuvre",
    Equipment : {
      Title : "Équipement",
      Units : "Équipement Quantité",
      Performance : "Équipement Performance"
    }
  }
}